<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Contracts</p>
        </div>
        <el-tabs type="border-card" v-model="active">
          <el-tab-pane label="CID" name="cid">
            <Table/>
          </el-tab-pane>
          <el-tab-pane label="Distro" name="distro">
            <DistroTable/>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/contracts/Table'
import DistroTable from '../components/contracts/DistroTable'
import { mapState, mapMutations } from 'vuex'


export default {
  data() {
    return {
      active: 'cid',
      type:'track'
    }
  },
  components: {
    DistroTable,
    Table
  },

  computed: {
    ...mapState('contracts', ['loading'])
  },
}
</script>
